import { setShiftTemplates, setLoading, setTemplatesForSelect } from './shiftTemplatesSlice';
import {
  listAllShiftTemplateService,
  getAllShiftTemplatesByPaginateService,
  getShiftTemplateByIdService,
  createShiftTemplateService,
  updateShiftTemplateService,
  deleteShiftTemplateService,
  restoreShiftTemplateService,
} from '../../services/shiftTemplates.service';
import { setCargosSelectRedux } from 'store/cargos';

export const storeGetShiftTemplatesAll = () => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    const resp = await listAllShiftTemplateService();
    if (resp?.ok) {
      await dispatch(setShiftTemplates(resp.data));
    }
    dispatch(setLoading(false));
    return resp;
  };
};

export const getShiftTemplatesSelectStore = () => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    const resp = await listAllShiftTemplateService();
    if (resp?.ok) {
      await dispatch(setTemplatesForSelect(resp.data));
    }
    dispatch(setLoading(false));
    return resp;
  };
};

export const storeGetAllShiftTemplatesByPaginate = (
  page: number,
  inputValue: string = '',
  status: number = 1
) => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    const resp = await getAllShiftTemplatesByPaginateService(page, 10, inputValue, status);
    if (resp?.ok) {
      dispatch(setShiftTemplates(resp.data));
      await dispatch(setCargosSelectRedux(resp.data.cargos));
    }
    dispatch(setLoading(false));
    return resp;
  };
};

export const storeCreateShiftTemplate = (data: any) => {
  return async () => {
    const resp = await createShiftTemplateService(data);
    return resp;
  };
};

export const storeUpdateShiftTemplate = (id: string, data: any) => {
  return async () => {
    const resp = await updateShiftTemplateService(id, data);
    return resp;
  };
};

export const storeGetShiftTemplateById = (id: string) => {
  return async () => {
    const resp = await getShiftTemplateByIdService(id);
    return resp;
  };
};

export const storeDeleteShiftTemplate = (
  id: string,
  inputValue: string,
  page: number,
  status: number = 1
) => {
  return async (dispatch: any) => {
    const resp = await deleteShiftTemplateService(id, inputValue, page, status);
    if (resp?.ok && resp.data) {
      dispatch(setShiftTemplates(resp.data));
    } else if (resp?.ok) {
      dispatch(storeGetAllShiftTemplatesByPaginate(page, inputValue, status));
    }
    return resp;
  };
};

export const storeRestoreShiftTemplate = (
  id: string,
  inputValue: string,
  page: number,
  status: number = 1
) => {
  return async (dispatch: any) => {
    const resp = await restoreShiftTemplateService(id, inputValue, page, status);
    if (resp?.ok && resp.data) {
      dispatch(setShiftTemplates(resp.data));
    } else if (resp?.ok) {
      dispatch(storeGetAllShiftTemplatesByPaginate(page, inputValue, status));
    }
    return resp;
  };
};
